export default "__VITE_ASSET__B5ds7WI3__"